<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
      <div class="row">
        <div class="col-md-12">
          <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
            #{{fc.ID.value}}
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group row">
                <div class="col-md-6 col-6">
                  <yt-dropdown-picklist #autofocus [ModelName]="'banka'" [GetName]="'get'" [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'"
                    [AllowAddNew]="false" formControlName="BankaID" [Label]="'FIRMAZRC.BANKA.SINGULAR'"
                    (OnItemSelected)="onBankaSelect($event)">
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && fc.BankaID.invalid">
                    <span *ngFor="let validation of errorMessages.BankaID">
                      <span class="error-message" *ngIf="fc.BankaID.hasError(validation.type)"><span
                          translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
                </div>
                <div class="col-md-6 col-6">
                    <yt-fw-zrc #zrcKontrola formControlName="Zrc" 
                      [ngClass]="{'is-invalid': submitted && fc.Zrc.invalid}"
                      [Label]="'FIRMAZRC.ZRC.SINGULAR'">
                    </yt-fw-zrc>
                    <div class="form-error" *ngIf="submitted && fc.Zrc.invalid">
                      <span *ngFor="let validation of errorMessages.Zrc">
                        <span class="error-message" *ngIf="fc.Zrc.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                    <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                      <span class="error-message"
                        *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.zrcControlNumbers && !this.baseFormGroup.errors.zrcControlNumbers.valid"><span
                          translate="{{this.baseFormGroup.errors.zrcControlNumbers.message}}"></span></span>
                    </div>
                  </div>
              </div>
            </div>           
          </div>
          <div class="row">
            <div class="col-md-12">      
      
              <div class="form-group row">
                <label class="col-form-label col-2"><span translate="FIRMAZRC.GLAVNI.SINGULAR"></span></label>
                <div class="col-md-1">
                  <input style="width: 20px;" type="checkbox" name="chkGlavni" class="form-control" formControlName="Glavni"
                    autocomplete="off">
                </div>
              </div>
              <div class="form-group row">
                <label class="col-form-label col-2"><span translate="FIRMAZRC.DEVIZNI.SINGULAR"></span></label>
                <div class="col-md-1">
                  <input style="width: 20px;" type="checkbox" name="chkDevizni" class="form-control" formControlName="Devizni"
                    autocomplete="off">
                </div>
              </div>
      
      
      
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-12">
            <div class="btn-group float-right">
                <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"  [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
            </div>
        </div>
      </div>

      
      <div class="row">
        <div class="col-md-12">          
          <yt-instrukcija-placanja-update-container
           #baseInlineContainer           
            [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'FirmaZrcID'"
            [ParentPropertyValue]="Item.ID" [Parameters]="TransferParameters">
          </yt-instrukcija-placanja-update-container>
          
        </div>
      </div> 
      <!-- [ModelData]="modelData" -->
    </form>
  </div>